export const JAVA_INTEGER_MAX = 2147483647;
export const NUMERIC_PREFERENCE_ERROR = 'Enter a non-negative whole number within the allowed range, or leave blank.';

export const isValidNumericPreference = (value) => {
  if (value === '' || value === null || value === undefined) {
    return true;
  }

  return /^\d+$/.test(String(value)) && Number(value) <= JAVA_INTEGER_MAX;
};

export const validateNumericPreference = (value) =>
  isValidNumericPreference(value) ? null : [{ isValid: false, message: NUMERIC_PREFERENCE_ERROR }];
